import React from "react";
import { useAppSelector } from "../../store/hooks";
import {
  findTemplateByStoredReference,
  getTemplateLinkedComponent,
  getTemplateSourceComponent,
} from "./utilities/templateHelpers";

import { defaultComponents } from "./interfaces/DefaultComponents";

import "./MegaMenuComponent.css";
import { getComponentIdentityKey } from "./utilities/componentIdentity";

export default function MegaMenuComponent({
  id,
  menuOpen,
  setMegaMenuOpen,
  leftPosition,
  topPosition,
}: any) {
  const templates = useAppSelector((state) => state.builder.templates);
  const components = useAppSelector(
    (state) => state.builder.structure.components
  );

  const megamenuTemplate = findTemplateByStoredReference(templates, id);

  if (!megamenuTemplate) {
    return <></>;
  }

  const megamenuTemplateComponent =
    getTemplateLinkedComponent(components, megamenuTemplate) ??
    getTemplateSourceComponent(megamenuTemplate as any);

  if (!megamenuTemplateComponent) {
    return <></>;
  }

  const ComponentToRender = defaultComponents[megamenuTemplateComponent.type];

  return (
    <div
      className={`megamenu_component ${menuOpen ? "visible" : ""}`}
      onMouseEnter={() => {
        setMegaMenuOpen(true);
      }}
      onMouseLeave={() => {
        setMegaMenuOpen(false);
      }}
      style={{
        visibility: menuOpen ? "visible" : "hidden",
        height: "auto",
        width: megamenuTemplateComponent?.attributes?.content_width_size
          ? megamenuTemplateComponent?.attributes?.content_width_size +
            megamenuTemplateComponent?.attributes?.content_width_unit
          : "auto",
        left: leftPosition + "px",
        top: topPosition + "px",
      }}
    >
      <ComponentToRender
        {...megamenuTemplateComponent}
        key={getComponentIdentityKey(megamenuTemplateComponent)}
      />
    </div>
  );
}
